{
    "NAME": "GebruikerslijstTaal",
    "UsersList_Column_FullName": "Volledige naam",
    "UsersList_Column_Username": "Gebruikersnaam",
    "UsersList_Column_LockOut": "Buitengesloten",
    "UsersList_Column_ActivityLastLogon": "Activiteit\/Laatste aanmelding",
    "UsersList_Tooltip_LastLogon_Label": "Laatste aanmelding",
    "UsersList_LastLogon_None": "Geen gegevens",
    "UsersList_Column_Permissions": "Toestemmingen",
    "UsersList_Column_TelSys": "Telefoonserver",
    "UsersList_LockOut_Yes": "Ja",
    "UsersList_LockOut_No": "Nee",
    "UsersList_Filter_UserType_Label": "Gebruikerstype",
    "UsersList_UserType_All": "Alle",
    "UsersList_UserType_ServiceWide": "Dienstverlening breed",
    "UsersList_UserType_SystemWide": "Systeembreed",
    "UsersList_UserType_Detached": "Losgemaakt",
    "UsersList_UserType_AdminInclusive": "Beheerders (inclusief)",
    "UsersList_UserType_AdminExclusive": "Beheerders (exclusief)",
    "UsersList_UserType_ReportingHistoricOnly": "Rapportage (alleen historische gegevens)",
    "UsersList_UserType_ReportingBLF": "Rapportage (BLF)",
    "UsersList_UserType_ReportingStd": "Rapportage (standaard)",
    "UsersList_UserType_ReportingACD": "Rapportage (ACD)",
    "UsersList_UserType_ReportingMobileAppAdvanced": "Rapportage (geavanceerde mobiele app)",
    "UsersList_UserType_SignedInNow": "Nu ingelogd",
    "UsersList_UserType_SignedInToday": "Vandaag ingelogd",
    "UsersList_UserType_SignedInThisWeek": "Deze week ingeschreven",
    "UsersList_UserType_SignedInThisMonth": "Deze maand ingeschreven",
    "UsersList_UserType_SignedInNever": "Nooit ingelogd",
    "UsersList_UserType_ActivityToday": "Activiteiten vandaag",
    "UsersList_UserType_ActivityThisWeek": "Activiteiten deze week",
    "UsersList_UserType_ActivityThisMonth": "Activiteiten deze maand",
    "UsersList_UserType_ActivityNone": "Geen activiteit",
    "UsersList_CopyReports_Button": "Kopieer rapporten naar",
    "UsersList_BulkAdd_Button": "In bulk toevoegen",
    "UsersList_SignInAs_Button": "Meld u aan als",
    "UsersList_SignInAs_Confirm": "Aanmelden als **{}**? U blijft in deze browsersessie als die gebruiker actief.",
    "UsersList_CopyReports_Dialog_Title": "Kopieer rapporten van **{} ({})**",
    "UsersList_CopyReports_Step_Reports": "Rapporten",
    "UsersList_CopyReports_Step_Targets": "Doelgroep",
    "UsersList_CopyReports_Step_Confirm": "Bevestigen",
    "UsersList_CopyReports_Intro_Reports": "Selecteer een of meer rapporten om te kopiëren uit **{}**.",
    "UsersList_CopyReports_Intro_Targets": "Selecteer een of meer gebruikers die een kopie van deze rapporten moeten ontvangen.",
    "UsersList_CopyReports_Confirm_Summary": "Je kopieert **{}** rapport(en) naar **{}** gebruiker(s).",
    "UsersList_CopyReports_Confirm_Report_Label": "Rapport kopiëren **{}**:",
    "UsersList_CopyReports_Confirm_Reports_Label": "Rapporten kopiëren: **{}**",
    "UsersList_CopyReports_Confirm_Target_Label": "Aan **{}** gebruiker:",
    "UsersList_CopyReports_Confirm_Targets_Label": "Aan **{}** gebruikers:",
    "UsersList_CopyReports_Overwrite_Label": "Vervang bestaande rapporten over doelgebruikers wanneer namen conflicteren.",
    "UsersList_CopyReports_Success": "Rapporten succesvol gekopieerd.",
    "UsersList_CopyReports_Cancel": "Annuleren",
    "UsersList_CopyReports_Back": "Rug",
    "UsersList_CopyReports_Next": "Volgende",
    "UsersList_CopyReports_Copy": "Kopieer rapporten",
    "UsersList_CopyReports_Column_Folder": "Map",
    "UsersList_CopyReports_Column_ReportName": "Rapport",
    "UsersList_CopyReports_Column_Type": "Type",
    "UsersList_CopyReports_Column_Username": "Gebruikersnaam",
    "UsersList_CopyReports_Column_FullName": "Volledige naam",
    "UsersList_CopyReports_Empty_Reports": "Er zijn geen rapporten beschikbaar om te kopiëren voor deze gebruiker.",
    "UsersList_CopyReports_Empty_Targets": "Er zijn geen geschikte doelgebruikers die in aanmerking komen voor deze kopieerbewerking."
}